import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["search", "tab", "siteButton"]

  connect() {
    this.site = ""
    this.layout()
    if (this.hasSearchTarget && this.searchTarget.value) this.filter()
  }

  // The grid is replaced when it switches to editing.
  refresh() {
    this.layout()
    this.filter()
  }

  filter() {
    const needle = this.hasSearchTarget ? this.fold(this.searchTarget.value) : ""
    if (this.hasSearchTarget) this.syncTabs(needle)
    this.element.querySelectorAll("#usersPermissions-container tr.pm-row").forEach(row => {
      const byName = needle === "" || this.fold(row.dataset.name).includes(needle)
      const bySite = this.site === "" || row.dataset.site === this.site
      row.hidden = !(byName && bySite)
    })
  }

  pickSite(event) {
    const button = event.currentTarget
    this.site = button.dataset.siteValue
    this.siteButtonTargets.forEach(other => other.setAttribute("aria-pressed", String(other === button)))
    this.filter()
  }

  layout() {
    this.element.querySelectorAll("[data-permissions-grid]").forEach(card => {
      const table  = card.querySelector(".pm-table")
      const scroll = card.querySelector(".pm-scroll")
      if (scroll) {
        scroll.style.maxHeight = Math.max(240, window.innerHeight - scroll.getBoundingClientRect().top - 24) + "px"
        const overflow = document.documentElement.scrollHeight - window.innerHeight
        if (overflow > 0) scroll.style.maxHeight = Math.max(240, parseInt(scroll.style.maxHeight, 10) - overflow) + "px"
      }
      if (!table) return

      const cols = parseInt(table.style.getPropertyValue("--pm-cols") || "0", 10)
      if (!cols) return

      const room  = card.clientWidth - 260 - 130 // the name column and the spacer
      const width = Math.max(44, Math.min(110, Math.floor(room / cols)))
      table.style.setProperty("--pm-col", width + "px")
      table.style.width = Math.max(card.clientWidth, 260 + cols * width + 130) + "px"
    })
  }

  syncTabs(needle) {
    const query = this.searchTarget.value.trim()
    this.tabTargets.forEach(tab => {
      const count = tab.querySelector("[data-total]")
      const hits  = needle === "" ? Number(count.dataset.total) : (this.names[tab.dataset.permissionsTab] || []).filter(name => this.fold(name).includes(needle)).length
      count.textContent = hits
      tab.classList.toggle("opacity-50", needle !== "" && hits === 0)
      tab.href = this.withQuery(tab.href, needle, query)
    })
    history.replaceState(history.state, "", this.withQuery(window.location.href, needle, query))
  }

  withQuery(href, needle, query) {
    const url = new URL(href)
    needle === "" ? url.searchParams.delete("q") : url.searchParams.set("q", query)
    return url.toString()
  }

  get names() {
    if (!this._names) this._names = JSON.parse(this.searchTarget.dataset.names || "{}")
    return this._names
  }

  fold(text) {
    return (text || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim()
  }
}
